import { TS_OfferFlight } from "../TravelSeller/Models/TS_OfferFlight";
import { BookingItemInterface } from "./BookingItemInterface";

export class OfferFlight extends TS_OfferFlight implements BookingItemInterface {}
